import React from "react";
import classNames from "classnames";
import ContentEditorComponent from "@components/ContentEditorView/ContentEditorComponent";

const Column = (props) => {
  const columnClass = classNames("osm-u-grid-col", "u-space-mt-0", {
    "u-space-p-20": props.fullPadding,
  });

  return (
    <div className={columnClass}>
      {props.children && <ContentEditorComponent content={props.children} />}
    </div>
  );
};

export default Column;
